import React from "react";
import PropTypes from "prop-types";
import TextFieldGroup from "../../reusable/TextFieldGroup";
import { Link } from "react-router-dom";
import NotificationAlert from "react-notification-alert";
import isEmpty from "lodash/isEmpty";
import Validator from "validator";
import { connect } from "react-redux";
import { contactUs } from "../../modules/actions/authActions";
import { PulseLoader, ClipLoader } from "react-spinners";
import ReCAPTCHA from "react-google-recaptcha";

function validateInput(data) {
  let errors = {};
  if (Validator.isEmpty(data.name)) {
    errors.name = "Name field is required";
  }
  if (Validator.isEmpty(data.email)) {
    errors.email = "Email field is required";
  }

  if (!Validator.isEmail(data.email)) {
    errors.email = "Enter valid Email ID";
  }
  if (Validator.isEmpty(data.subject)) {
    errors.subject = "Subject field is required";
  }
  if (Validator.isEmpty(data.message)) {
    errors.message = "Message field is required";
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
}
class ContactContent extends React.Component {
  recaptchaRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      subject: "",
      message: "",
      errors: {},
      successMsg: "",
      isLoading: false,
      invalid: false,
      isHuman: false,
      humanKey: null
    };
  }

  _onChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    this.setState({ [field]: value });
  };

  handleContactUs = event => {
    event.preventDefault();
    if (this.isValid()) {
      const { name, email, subject, message, humanKey } = this.state;

      const contactPayload = {
        name,
        email,
        subject,
        message,
        humanKey
      };
      this.setState({ errors: {}, isLoading: true });
      this.props
        .contactUs(contactPayload)
        .then(data => {
          console.log(data);
          if (data.status) {
            this.setState({ isLoading: false });
            this.refs.notify.notificationAlert({
              place: "tc",
              message: (
                <div>
                  <div>
                    <b>{data.message}</b>
                  </div>
                </div>
              ),
              type: "success",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          } else {
            this.setState({ isLoading: false });
            this.refs.notify.notificationAlert({
              place: "tc",
              message: (
                <div>
                  <div>
                    <b>{data.message}</b>
                  </div>
                </div>
              ),
              type: "danger",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          }
          this.recaptchaRef.current.reset();
          this.setState({isHuman: false, humanKey: null});
        })
        .catch(error => {
          this.setState({ isLoading: false });
          this.refs.notify.notificationAlert({
            place: "tc",
            message: (
              <div>
                <div>
                  <b>{error.response.data.message}</b>
                </div>
              </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
          });
          this.recaptchaRef.current.reset();
          this.setState({isHuman: false, humanKey: null});
        });
    }
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }

  // ReCAPTCHA Client Side
  verifyCaptcha = (res) => {
    if(res) {
      this.setState({ isHuman: true, humanKey: res })
    }
  }

  // ReCAPTCHA Expired
  expireCaptcha = () => {
    this.setState({ isHuman: false, humanKey: null })
  }

  render() {
    const { errors, successMsg, name, email, subject, message } = this.state;
    return (
      <section className="section">
        <div className="container">
          <div className="row">
            <PulseLoader
              className="sweet-loading"
              sizeUnit={"px"}
              size={20}
              color={"#123abc"}
              loading={this.state.isLoading}
            />
            <div className="col-lg-6">
              <div className="contact_icon_box mt-3 rounded">
                <div className="text-center p-3 m-2 bg-light">
                  <div className="contact-icon text-custom">
                    <i className="pe-7s-phone" />
                  </div>
                  <div className="contact-detail mt-3">
                    <h6 className="SansSerif">Call Us</h6>
                    <p className="text-muted mb-0 mt-3">+201-731-3839</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="contact_icon_box mt-3 rounded">
                <div className="text-center p-3 m-2 bg-light">
                  <div className="contact-icon text-custom">
                    <i className="pe-7s-mail" />
                  </div>
                  <div className="contact-detail mt-3">
                    <h6 className="SansSerif">Email Us</h6>
                    <p className="text-muted mb-0 mt-3">
                    support@mightywifi.net
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/*
            <div className="col-lg-4">
              <div className="contact_icon_box mt-3 rounded">
                <div className="text-center p-3 m-2 bg-light">
                  <div className="contact-icon text-custom">
                    <i className="pe-7s-map-marker" />
                  </div>
                  <div className="contact-detail mt-3">
                    <h6>Visit Office</h6>
                    <p className="text-muted">
                      560 Sylvan Ave. Englewood Cliffs NJ
                    </p>
                  </div>
                </div>
              </div>
            </div>
            */}
          </div>
          <div className="row mt-3 vertical-content">
            <div className="col-lg-6">
              <div className="mt-3">
                <img
                  src="images/mightywifi-cloud-1.jpg"
                  alt="Mightywifi US and Global hotspot wifi device"
                  className="img-fluid mx-auto d-block"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="contact_form mt-3">
                <NotificationAlert ref="notify" />
                <form onSubmit={this.handleContactUs}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group mt-3">
                        <input
                          placeholder="Name"
                          className="form-control"
                          type="text"
                          onChange={this._onChange}
                          value={name}
                          name="name"
                        />
                        {errors.name && (
                          <span className="error-color-dash">
                            {errors.name}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group mt-3">
                        <input
                          placeholder="Email Address"
                          className="form-control"
                          type="text"
                          onChange={this._onChange}
                          value={email}
                          name="email"
                        />
                        {errors.email && (
                          <span className="error-color-dash">
                            {errors.email}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group mt-3">
                        <input
                          placeholder="Subject"
                          className="form-control"
                          type="text"
                          onChange={this._onChange}
                          value={subject}
                          name="subject"
                        />
                        {errors.subject && (
                          <span className="error-color-dash">
                            {errors.subject}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group mt-3">
                        <textarea
                          name="comments"
                          id="comments"
                          rows="4"
                          onChange={this._onChange}
                          value={message}
                          name="message"
                          className="form-control"
                          placeholder="Message"
                        />
                        {errors.message && (
                          <span className="error-color-dash">
                            {errors.message}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group mt-3">
                        <ReCAPTCHA
                            ref={this.recaptchaRef}
                            sitekey={'6LdUIyweAAAAAOs44Nk0ouoOHyz1YlbNMCJuBHfo'}
                            // render="explicit"
                            onChange={this.verifyCaptcha}
                            onExpired={this.expireCaptcha}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 text-right">
                      <input
                        type="submit"
                        className="btn btn-custom"
                        value="Send Message"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}
export default connect(
  mapStateToProps,
  {
    contactUs
  }
)(ContactContent);



// WEBPACK FOOTER //
// ./src/pages/contact/ContactContent.js